import { IDeserialize } from "./abstraction/IDeserialize";

export class Announcement implements IDeserialize<Announcement> {
  announcementId: number;
  validFrom: Date;
  validUntil: Date;
  notificationType: AnnouncementNotificationType;

  deserialize(dto?: Announcement): Announcement {
    if (dto) {
      Object.assign(this, dto);
      this.validFrom = new Date(this.validFrom);
      this.validUntil = new Date(this.validUntil);
      this.notificationType = AnnouncementNotificationType[this.notificationType];
    }

    return this;
  }
}

export interface SeenAnnouncements {
  announcementIds: number[];
}

export enum AnnouncementNotificationType {
  Information = "information",
  Warning = "warning",
  Error = "error",
}
